.list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.account {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 8px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-primary);
  font: inherit;
  text-align: start;
  cursor: pointer;

  &:hover:not(:disabled),
  &:focus-visible {
    background: var(--color-bg-secondary);
  }

  &:disabled {
    cursor: default;
  }
}

.name {
  flex: 1 1 auto;
  min-width: 0;

  // The sizes names have next to posts (SiteThemes#name_sizes)
  font-size: var(--theme-name-size, 15px);
  line-height: calc(var(--theme-name-size, 15px) + 7px);

  :global(.display-name__account) {
    display: block;
    font-size: var(--theme-handle-size, 13px);
    line-height: calc(var(--theme-handle-size, 13px) + 5px);
    color: var(--color-text-secondary);
  }
}

.check {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  color: var(--color-text-brand);
}

.hint,
.error {
  margin-top: 12px;
  font-size: 14px;
}

.hint {
  color: var(--color-text-secondary);
}

.error {
  color: var(--color-text-error);
}
